<template>
    <div id="cookie-banner"></div>
</template>

<script>
    import Content from "/src/data/content";
    let lang = process.env.VUE_APP_LOCALITY;

    export default {
        mounted() {
            window.addEventListener('load', () => this.addCookies());
        },
        setup() {
        return {
            isGB: lang == 'gb_en' ? true : false,
        }
        },
        methods: {
            addCookies() {
                let cookie;
                let name = "je-cookieConsent=";
                let decodedCookie = decodeURIComponent(document.cookie);
                let ca = decodedCookie.split(';');

                for(let i = 0; i <ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        cookie = c.substring(name.length, c.length);
                    }
                }

                if (cookie == undefined) {
                    const cookieScript = document.createElement("script");
                    cookieScript.setAttribute(
                        "src",
                        "https://unpkg.com/@justeat/f-cookie-banner@4.5.0/dist/static/en-GB.js"
                    );
                    document.head.appendChild(cookieScript);

                    setTimeout(() => {

                        let acceptCookie = document.getElementsByClassName('Button_o-btn_1KX8u');
                        acceptCookie[0].addEventListener('click', function() {
                            window.dataLayer = window.dataLayer || [];
                            dataLayer.push({
                                "event": "trackPageview",
                                "page_name": "Delco Courier Recruitment Landing Page",
                                "page_id": "e3502a25-95e1-4e1e-8b7a-c19b3f6855b2",
                                "platform_country" : Content[lang].gtm.countryPlatform,
                                "platform_environment" : "production",
                                "platform_language" :  Content[lang].gtm.platform_language,
                                "user_anonymousId" :  "58a7d972-df88-44b0-b2bd-89ea37031ba6",
                            });
                        })
                    }, 1000);
                } else {
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        "event": "trackPageview",
                        "page_name": "Delco Courier Recruitment Landing Page",
                        "page_id": "e3502a25-95e1-4e1e-8b7a-c19b3f6855b2",
                        "platform_country" : Content[lang].gtm.countryPlatform,
                        "platform_environment" : "production",
                        "platform_language" :  Content[lang].gtm.platform_language,
                        "user_anonymousId" :  "58a7d972-df88-44b0-b2bd-89ea37031ba6",
                    });
                }
        }
    }
};
</script>